import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appCurrencyInput]',
  standalone: true
})
export class CurrencyInputDirective {
    private clickTimeout: any;

    constructor(private el: ElementRef<HTMLInputElement>) { }

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent) {
        const inputElement = this.el.nativeElement;
        const currentValue = inputElement.value;
        const currentSelectionLength = inputElement.selectionEnd! - inputElement.selectionStart!;
        clearTimeout(this.clickTimeout);

        this.clickTimeout = setTimeout(() => {
            if (currentValue === '$0.00') {
                const selectionLength = inputElement.selectionEnd! - inputElement.selectionStart!;
                if (selectionLength !== currentValue.length) {
                    inputElement.setSelectionRange(1, 1);
                }
            }
        }, 200);

        if (currentSelectionLength === currentValue.length) {
            return true;
        }

        if (currentValue === '$0.00') {
            inputElement.setSelectionRange(1, 1);
            return;
        }

        const hasDollarSign = currentValue.includes('$');
        const caretPosition = inputElement.selectionStart!;
        const hasDollarSignBeforeCaret = currentValue.slice(0, caretPosition).includes('$');

        if (!hasDollarSignBeforeCaret && hasDollarSign) {
            const dollarSignIndex = currentValue.indexOf('$');
            inputElement.setSelectionRange(dollarSignIndex + 1, dollarSignIndex + 1);
        }
    }

    @HostListener('dblclick', ['$event'])
    onDoubleClick(event: MouseEvent) {
        clearTimeout(this.clickTimeout);
        this.el.nativeElement.select(); // Select all text on double click
    }
}
